module.exports = __webpack_public_path__ + "static/img/Rory_Lobb_desktop.91697a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rory_Lobb_desktop.jpg
// module id = 2LOT
// module chunks = 0